(function(){
  var scrim=null, sortPanel=null, lastOpen=null;
  var SORTS=[['Recommended','manual'],['New arrivals','created-descending'],['Price: Low to High','price-ascending'],['Price: High to Low','price-descending']];
  function isPhone(){try{return window.matchMedia('(max-width: 749px)').matches;}catch(e){return window.innerWidth<750;}}
  function sortUrl(val){var u=new URL(location.href);u.searchParams.set('sort_by',val);return u.pathname+u.search;}
  function tmpl(){var m=document.querySelector('#MainContent');return m&&m.dataset?m.dataset.template:'';}
  function facetsEl(){return document.querySelector('.facets.facets--vertical');}
  function drawerEl(){return document.querySelector('dialog-component#filters-drawer');}
  /* Phones: the theme hides .facets--vertical under 750px, so we open the theme's native filter drawer instead. */
  /* Make the native drawer look like the rest of the Vexillum panels: page colour scheme (dark scheme in dark mode), 'Refine' title. */
  function styleNativeDrawer(){
    var d=drawerEl();if(!d)return;
    var dark=document.documentElement.getAttribute('data-vex-theme')==='dark';
    var want=dark?'color-scheme-7':'color-scheme-1';
    if(!d.classList.contains(want)){
      Array.prototype.slice.call(d.classList).forEach(function(c){if(c.indexOf('color-scheme')===0)d.classList.remove(c);});
      d.classList.add(want);
    }
    if(!d.classList.contains('vex-native-drawer'))d.classList.add('vex-native-drawer');
    var h=d.querySelector('#filters-drawer-heading');
    if(h&&h.firstChild&&h.firstChild.nodeType===3&&h.firstChild.nodeValue.trim()!=='Refine'){h.firstChild.nodeValue='Refine ';}
  }
  function openNativeDrawer(){
    var d=drawerEl();if(!d)return false;
    styleNativeDrawer();
    try{if(typeof d.showDialog==='function'){d.showDialog();return true;}}catch(e){}
    var dlg=d.querySelector('dialog');
    if(dlg){try{if(!dlg.open)dlg.showModal();return true;}catch(e){}}
    return false;
  }
  function openRefine(){
    if(isPhone()&&openNativeDrawer())return;
    var f=facetsEl();if(f){ensureHead(f);openPanel(f,'facets');}
  }
  function mkBtn(txt){var b=document.createElement('button');b.type='button';b.className='vex-refine-btn';b.textContent=txt;return b;}
  function mkHead(label){var h=document.createElement('div');h.className='vex-refine-head';var t=document.createElement('span');t.className='vex-refine-title';t.textContent=label;var c=document.createElement('button');c.type='button';c.className='vex-refine-close';c.setAttribute('aria-label','Close');c.innerHTML='&times;';c.addEventListener('click',shutAll);h.appendChild(t);h.appendChild(c);return h;}
  function ensureScrim(){if(!scrim||!document.body.contains(scrim)){scrim=document.createElement('div');scrim.className='vex-refine-scrim';scrim.addEventListener('click',shutAll);document.body.appendChild(scrim);}}
  function shutAll(){lastOpen=null;var f=facetsEl();if(f)f.classList.remove('vex-open');if(sortPanel)sortPanel.classList.remove('vex-open');if(scrim)scrim.classList.remove('on');document.body.style.overflow='';}
  function openPanel(p,which){ensureScrim();var f=facetsEl();if(f)f.classList.remove('vex-open');if(sortPanel)sortPanel.classList.remove('vex-open');p.classList.add('vex-open');scrim.classList.add('on');document.body.style.overflow='hidden';lastOpen=which;}
  function ensureSortPanel(){
    if(sortPanel&&document.body.contains(sortPanel))return;
    sortPanel=document.createElement('div');sortPanel.className='vex-sort-panel';sortPanel.appendChild(mkHead('Sort'));
    var cur=new URL(location.href).searchParams.get('sort_by')||'manual';
    SORTS.forEach(function(o){var a=document.createElement('a');a.className='vex-sort-opt'+(o[1]===cur?' is-active':'');a.textContent=o[0];a.href=sortUrl(o[1]);sortPanel.appendChild(a);});
    document.body.appendChild(sortPanel);
  }
  function ensureHead(f){if(f&&!f.querySelector('.vex-refine-head'))f.insertBefore(mkHead('Refine'),f.firstChild);}
  function ensureBarCollection(){
    if(document.querySelector('.vex-refine-bar'))return;
    var g=document.querySelector('.product-grid-container')||document.querySelector('results-list');
    if(!g||!g.parentElement)return;
    var bar=document.createElement('div');bar.className='vex-refine-bar';
    var s=mkBtn('Sort'),r=mkBtn('Refine');
    s.addEventListener('click',function(){ensureSortPanel();openPanel(sortPanel,'sort');});
    r.addEventListener('click',openRefine);
    bar.appendChild(s);bar.appendChild(r);
    g.parentElement.insertBefore(bar,g);
  }
  function ensureBarHome(){
    if(document.querySelector('.vex-refine-bar'))return;
    var g=document.querySelector('.resource-list');if(!g||!g.parentElement)return;
    var bar=document.createElement('div');bar.className='vex-refine-bar';
    [['Sort','#vexsort'],['Refine','#vexrefine']].forEach(function(o){var a=document.createElement('a');a.className='vex-refine-btn';a.textContent=o[0];a.href='/collections/all'+o[1];bar.appendChild(a);});
    g.parentElement.insertBefore(bar,g);
  }
  function openFromHash(){
    if(location.hash==='#vexrefine'){var f=facetsEl();if((f&&f.querySelector('input'))||drawerEl()){openRefine();history.replaceState(null,'',location.pathname+location.search);}}
    else if(location.hash==='#vexsort'){ensureSortPanel();openPanel(sortPanel,'sort');history.replaceState(null,'',location.pathname+location.search);}
  }
  function tidyOrReopen(){
    var f=facetsEl();
    if(lastOpen==='facets'&&f&&!f.classList.contains('vex-open')){ensureHead(f);ensureScrim();f.classList.add('vex-open');scrim.classList.add('on');document.body.style.overflow='hidden';return;}
    if(lastOpen==='sort'&&sortPanel&&!sortPanel.classList.contains('vex-open')){ensureScrim();sortPanel.classList.add('vex-open');scrim.classList.add('on');return;}
    var anyOpen=(f&&f.classList.contains('vex-open'))||(sortPanel&&sortPanel.classList.contains('vex-open'));
    if(scrim&&!anyOpen&&scrim.classList.contains('on')){scrim.classList.remove('on');document.body.style.overflow='';}
  }
  function run(){
    try{
      var f=facetsEl();
      if(f&&f.querySelector('input')){ensureScrim();ensureSortPanel();ensureHead(f);ensureBarCollection();styleNativeDrawer();tidyOrReopen();openFromHash();}
      else if(tmpl()==='index'){ensureBarHome();}
    }catch(e){}
  }
  function saveOrRestore(){
    try{if(location.hash==='#vexrefine'||location.hash==='#vexsort')return;var path=location.pathname,qs=location.search,key='vexFilters';
      if(/[?&]filter\./.test(qs)){localStorage.setItem(key,JSON.stringify({path:path,q:qs,ts:Date.now()}));}
      else{var raw=localStorage.getItem(key);if(!raw)return;var o=JSON.parse(raw);if(o&&o.path===path&&o.q&&(Date.now()-o.ts)<1200000){location.replace(path+o.q);}}
    }catch(e){}
  }
  saveOrRestore();
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
  document.addEventListener('shopify:section:load',run);
  var t;var obs=new MutationObserver(function(){clearTimeout(t);t=setTimeout(run,80);});
  obs.observe(document.body,{childList:true,subtree:true});
})();
